class DiscountCode extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-discount-code-copy]');
    this.copyCode = this.copyCode.bind(this);

    if (this.button) {
      this.button.addEventListener('click', this.copyCode);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.copyCode);
    }
  }

  selectCode(code) {
    const selection = window.getSelection();
    if (!selection) return;

    const range = document.createRange();
    range.selectNodeContents(code);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  showSuccess() {
    this.button.classList.remove('is-copied');
    void this.button.offsetWidth;
    this.button.classList.add('is-copied');
  }

  async copyCode() {
    const code = document.getElementById(this.button.dataset.codeId);
    const status = document.getElementById(this.button.getAttribute('aria-describedby'));
    if (!code || !status) return;

    const discountCode = code.textContent.trim();
    this.button.disabled = true;
    status.textContent = '';

    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        throw new Error('Clipboard unavailable');
      }

      await navigator.clipboard.writeText(discountCode);
      this.showSuccess();
      status.textContent = this.button.dataset.copiedMessage;
    } catch (error) {
      this.selectCode(code);
      this.showSuccess();
      status.textContent = this.button.dataset.manualCopyMessage;
    } finally {
      this.button.disabled = false;
    }
  }
}

if (!window.customElements.get('discount-code')) {
  window.customElements.define('discount-code', DiscountCode);
}
